// import React from "react";
// import { motion } from "framer-motion";
// import "../home.css";
// import cert1 from "../Image/Home1.jpg";
// import cert2 from "../Image/Home2.jpg";
// import cert3 from "../Image/Home1.jpg";
// const logos = [
//   { id: 1, src: cert1, alt: "MCA" },
//   { id: 2, src: cert2, alt: "MSME" },
//   { id: 3, src: cert3, alt: "Digital India" },
// ];

// const CertifiedSection = () => {
//   return (
//     <div className="certified-container">
//       <motion.h2
//         initial={{ opacity: 0, y: -20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.6 }}
//         viewport={{ once: true, amount: 0.4 }}
//       >
//         We are Proudly Certified by
//       </motion.h2>

//       <motion.p
//         initial={{ opacity: 0 }}
//         whileInView={{ opacity: 1 }}
//         transition={{ delay: 0.4, duration: 0.8 }}
//         viewport={{ once: true, amount: 0.4 }}
        
//         className="certified-text"
//       >
//         We're thrilled to announce  has been certified
//         for its outstanding educational offerings, assuring professionals and
//         students of our commitment to excellence.
//       </motion.p>

//       <div className="certified-logos">
//         {logos.map((logo, index) => (
//           <motion.img
//             key={logo.id}
//             src={logo.src}
//             alt={logo.alt}
//             className="logo-img"
//             initial={{ opacity: 0, scale: 0.8 }}
//             whileInView={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.6, delay: index * 0.3 }}
//             viewport={{ once: true }}
//             whileHover={{ scale: 1.1 }}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default CertifiedSection;


import React from "react";
import { motion } from "framer-motion";
import "../home.css";

import cert1 from "../Image/MCA.png";
import cert2 from "../Image/DI.png";
import cert3 from "../Image/MSME.png";

const logos = [
  { id: 1, src: cert1, alt: "MCA" },
  { id: 2, src: cert2, alt: "MSME" },
  { id: 3, src: cert3, alt: "Digital India" },
];



// Reusable smooth animation variants
const textVariant = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: "easeOut" } },
};

const cardVariant = {
  hidden: { opacity: 0, scale: 0.85, y: 30 },
  show: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { duration: 0.9, ease: "easeOut" },
  },
};

const CertifiedSection = () => {
  return (
    <motion.div
      className="certified-container"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.3 }}
    >
      {/* Smooth Heading */}
      <motion.h2 variants={textVariant}>
        We are Proudly Certified by
      </motion.h2>

      {/* Smooth Paragraph */}
      <motion.p
        variants={textVariant}
        transition={{ delay: 0.2 }}
        className="certified-text"
      >
      We are thrilled to announce that Acadme is now proudly backed by government certifications—empowering every learner with trusted credentials, industry-level programs, and a future they can confidently build.
      </motion.p>

      {/* Logos appearing smooth in sequence */}
      
      <motion.div
        className="certified-logos"
        initial="hidden"
        whileInView="show"
        transition={{ staggerChildren: 0.25 }}
        viewport={{ once: true }}
      >
        {logos.map((logo) => (
          <motion.img
            key={logo.id}
            src={logo.src}
            alt={logo.alt}
            variants={cardVariant}
            whileHover={{
              scale: 1.14,
              transition: { type: "spring", stiffness: 200 },
            }}
            className="logo-img"
          />
        ))}
      </motion.div>
    </motion.div>
  );
};

export default CertifiedSection;
